import { Link } from 'react-router-dom';
import { IoTrophy, IoTrendingUp, IoLink, IoInformationCircle, IoMailSharp, IoCalendarSharp, IoNewspaperSharp, IoHomeSharp} from 'react-icons/io5';
import "./Navbar.css";

export default function Navbar({ onNavigate }) {
    return (
        <nav className='navbar' onClick={onNavigate}>
            <ul>
                <li><Link to="/"><IoHomeSharp/>Home</Link></li>
                <li><Link to="notice/tournament"><IoTrophy/>Tournament</Link></li>
                <li><Link to="league"><IoTrendingUp/>League</Link></li>
                <li><Link to="resource"><IoLink/>Resources</Link></li>
                <li><Link to="notice"><IoNewspaperSharp/>Notices</Link></li>
                <li><Link to="calendar"><IoCalendarSharp/>Calendar</Link></li>
                <li><Link to="about"><IoInformationCircle/>About Us</Link></li>
                <li><Link to="contact"><IoMailSharp/>Contact Us</Link></li>
            </ul>
        </nav>
    );
}